import {getManagerHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode} from "../../assets/functions";
import {getAllManagers} from "../Managers/functions";

export const getAllStoragemen = async () => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'storagemen', {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}
export const getAllStoragemanObject = async () => {
    const allStoragemen = await getAllStoragemen();
    const allStoragemenObject = allStoragemen.map((storageman) => {
        return {
            id : storageman.person.id,
            value : storageman.person.id,
            label : `${storageman.person.firstname} ${storageman.person.lastname} (${storageman.person.activePhonenumber})`
        };
    })

    return allStoragemenObject;
}
export const getStoragemanById = async (id) => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + `storagemen/${id}`, {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}